/*
 * What the next press of a shutter takes, shown on the shutter itself
 * (docs/UX_AUDIT_2026-10-24.md, recommendation 8): a camera armed for a burst
 * or a Z-stack must not look like one set for a single photo. Nothing for a
 * single photo, "×5" for a burst of five, "±" for an exposure bracket, "Z"
 * for a Z-stack. `capture` is useCaptureMode()'s answer.
 */
export function shotBadge(mode, frames) {
  if (mode === 'burst') return `×${frames}`;
  if (mode === 'bracket') return '±';
  if (mode === 'zstack') return 'Z';
  return '';
}

/** The shutter's name for a screen reader when it is armed for more than one photo, else null. */
export function shotLabel(t, mode, frames) {
  if (!shotBadge(mode, frames)) return null;
  return t(`capture.shutter.${mode}`, { count: frames });
}

export default function ShotBadge({ capture, style, testId }) {
  const text = capture ? shotBadge(capture.mode, capture.frames) : '';
  if (!text) return null;
  return (
    <span aria-hidden="true" data-testid={testId} style={{ ...BADGE, ...style }}>
      <bdi dir="ltr">{text}</bdi>
    </span>
  );
}

const BADGE = {
  minWidth: 22, height: 22, padding: '0 5px', borderRadius: 999, boxSizing: 'border-box', display: 'inline-flex',
  alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 800, lineHeight: 1,
  background: 'var(--c-primary)', color: 'var(--c-on-accent)', border: '1px solid rgba(255, 255, 255, 0.85)',
};
